import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentDetailPage } from "@/pages/Admin/legal/LegalDocumentDetailPage";

export const Route = createFileRoute("/app/admin/legal/$document_id")({
  component: LegalDocumentDetailRoute,
});

function LegalDocumentDetailRoute() {
  const { document_id } = Route.useParams();
  return <LegalDocumentDetailPage documentId={document_id} />;
}
